import { useTheme } from '@/features/theme/themeContext';
import { useI18n } from '@/i18n/context';
import { Icon } from './Icon';
import styles from './ThemeToggle.module.css';

/**
 * Light / dark switch. Shows the mode it switches TO (moon in light mode,
 * sun in dark mode); the accessible name says the same in words.
 */
export function ThemeToggle({ tone = 'default', className }: { tone?: 'default' | 'onDark'; className?: string }) {
  const { t } = useI18n();
  const { theme, toggleTheme } = useTheme();
  const label = theme === 'dark' ? t.common.themeToLight : t.common.themeToDark;
  return (
    <button
      type="button"
      className={[styles.toggle, tone === 'onDark' ? styles.onDark : '', className ?? ''].join(' ')}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      data-theme-toggle={theme}
    >
      <Icon name={theme === 'dark' ? 'sun' : 'moon'} size={18} />
    </button>
  );
}
